import React, {Component, Fragment} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData, postData} from '../../api/doLogin.js';
import {getFormFieldValue, setFormFieldValue} from "../Applications/shared/shared";
import {displayApplicantStatus, getApplicantStatusList} from "./StatusConstants";
import {checkPerms} from "../../api/permissions";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {AssignAccessCode} from "./views/AssignAccessCode";
import {EventClient} from "../../util/eventClient";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class CareerApplicantList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataLoaded: false,
      editMode: {},
      showAddCode: false,
      templates: []
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 5,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false,
      defaultSortName: "received",
      defaultSortOrder: "desc"
    }

    this.canDelete = checkPerms(props.perms, [{admin: {careers: [3]}}]);
  }

  componentDidMount() {
    this.updateData();
    this.updateTemplates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type) {
      this.updateData();
    }
  }

  updateData() {
    var self = this;
    getData("careers/applicants?type=" + this.props.match.params.type, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({data: data.data.careers, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  saveData(obj) {
    var self = this;
    postData("careers/applicant", {formData: obj, action: "save"}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const newData = self.state.data;
          newData.map((row, ind) => {
            if (row.id === data.data['id']) {
              newData[ind] = data.data;
            }
          });
          self.setState({editID: {}, data: newData});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  deleteData(obj) {
    var self = this;
    postData("careers/applicant/delete", {formData: obj, action: "delete"}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const newData = [];
          self.state.data.map((row, ind) => {
            if (row['id'] !== data.data['id']) {
              newData.push(row);
            }
          });
          self.setState({editID: {}, data: newData});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  updateTemplates() {
    var self = this;
    getData("careers/templates", {}, this.props.token)
      .then((data) => {
        console.log(data);
        if (data.status === "Success") {
          self.setState({templates: data.data, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  buttonFormatter(cell, row, context) {
    return (
      <button
        onClick={() => context.setState({editID: row})}>Edit</button>
    );
  }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['editID'], false, (data) => this.setState({editID: data}));
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"/>Careers Applicants

              <div className="card-actions">
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data} version="4" striped hover pagination sort search
                              options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataSort>Name</TableHeaderColumn>
                <TableHeaderColumn dataField="phone" dataFormat={(cell, row) => {
                  let dateStr = new Date(cell);
                  return `${row['phone']}<br/>${row['email']}`;
                }}>Contact</TableHeaderColumn>
                <TableHeaderColumn dataField="location" dataSort>Location</TableHeaderColumn>
                <TableHeaderColumn dataField="status" dataSort
                                   dataFormat={(cell) => displayApplicantStatus(cell)}>Status</TableHeaderColumn>
                <TableHeaderColumn dataField="received" dataSort dataFormat={(cell, row) => {
                  let dateStr = new Date(cell);
                  return `${dateStr.toDateString()}`;
                }}>Received</TableHeaderColumn>
                <TableHeaderColumn dataField="button"
                                   dataFormat={(cell, row) => this.buttonFormatter(cell, row, this)}>Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}
        {this.state.editID && this.state.editID['id'] && (
          <Modal isOpen={true}
                 className={'modal-lg ' + this.props.className}>
            <ModalHeader>Applicant - {this.state.editID['name']}</ModalHeader>
            <ModalBody>
              <Row>
                <Col xs={"3"}>
                  <FormGroup>
                    <Label htmlFor="name">Name</Label>
                    <Input type="text" id="name" placeholder=""
                           value={getFormFieldValue(this.state.editID['name'])}
                           onChange={(evt) => this.formsUpdater(evt)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={"3"}>
                  <FormGroup>
                    <Label htmlFor="phone">Phone</Label>
                    <Input type="text" id="phone" placeholder=""
                           value={getFormFieldValue(this.state.editID['phone'])}
                           onChange={(evt) => this.formsUpdater(evt)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={"4"}>
                  <FormGroup>
                    <Label htmlFor="email">Email</Label>
                    <Input type="text" id="email" placeholder=""
                           value={getFormFieldValue(this.state.editID['email'])}
                           onChange={(evt) => this.formsUpdater(evt)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={"3"}>
                  <FormGroup>
                    <Label htmlFor="referredBy">Referral</Label>
                    <Input type="text" id="referredBy" placeholder=""
                           value={getFormFieldValue(this.state.editID['referredBy'])}
                           onChange={(evt) => this.formsUpdater(evt)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={"3"}>
                  <FormGroup>
                    <Label htmlFor="status">Status</Label>
                    <Input type="select" id="status" placeholder=""
                           value={getFormFieldValue(this.state.editID['status'])}
                           onChange={(evt) => this.formsUpdater(evt)}
                    >
                      {getApplicantStatusList().map((val, i) => {
                        return <option key={i} value={val}>{displayApplicantStatus(val)}</option>
                      })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="10">
                  <FormGroup>
                    <Label htmlFor="comments">Comments</Label>
                    <Input type="textarea" name="comments" id="comments" rows="4"
                           placeholder="Content..."
                           value={getFormFieldValue(this.state.editID['comments'])}
                           onChange={(evt) => this.formsUpdater(evt)}/>
                  </FormGroup>
                </Col>
              </Row>

            </ModalBody>
            <ModalFooter>
              <Button color="secondary"
                      onClick={() => this.setState({showAddCode: true})}>Grant Access</Button>
              {this.canDelete && (
                <Button color="danger"
                        onClick={() => {
                          if (confirm('Are you sure you want to delete this applicant?')) {
                            this.deleteData(this.state.editID);
                          }
                        }
                        }>Delete</Button>
              )}
              <Button color="primary"
                      onClick={() => this.saveData(this.state.editID)}>Save</Button>
              <Button color="secondary"
                      onClick={() => this.setState({editID: {}})}>Close</Button>
            </ModalFooter>
          </Modal>
        )}
        {this.state.showAddCode && (

          <MakeDialog isOpen={this.state.showAddCode} header="Add Access">
            <AssignAccessCode
              onSave={() => {
                this.setState({showAddCode: false, editID: {...this.state.editID}});
              }}
              templates={this.state.templates['templates'] || []}
              input={{name: this.state.editID['name'], email: this.state.editID['email'], id: this.state.editID['id']}}
              edit={{}}
              footer={(
                <Fragment>
                  <Button color="primary"
                          onClick={() => EventClient.emit("ACCESS_CODE_SAVE", null)}>Save</Button>
                  <Button color="secondary"
                          onClick={() => this.setState({showAddCode: false})}>Close</Button>
                </Fragment>
              )}/>
          </MakeDialog>
        )}
      </div>
    )
  }
}

export default CareerApplicantList;



// WEBPACK FOOTER //
// ./src/containers/Careers/CareerApplicantList.js